import React from 'react';
import { Badge } from 'Components/frameworks/badge/Badge';
import { PopOver } from 'Components/frameworks/pop-over/PopOver';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { capitalizeFromUppercase } from 'Utils/string/stringUtils';
import { t } from 'Src/i18n';
import { FacetLabel } from './FacetLabel';
type Props = {
  activeCustomFacets: any;
  activeFacets: any;
  capitalizeLabels?: boolean;
  facets: Array<SearchFacetList>;
  isWorldMapFullScreen?: boolean;
};
// eslint-disable-next-line clubmed/no-fake-component
export const getChoices = ({
  activeCustomFacets,
  activeFacets,
  capitalizeLabels = false,
  facets,
  isWorldMapFullScreen = false,
}: Props) => {
  // Safeguard: API can return facets with null names, that must be ignored.
  return facets
    ?.filter(({ badgeIconProps, label }) => Boolean(badgeIconProps?.iconName || label))
    .map(({ badgeIconProps, label, count, value }) => {
      const isCruiseOrTour = value === '5_CRUISE' || value === '0_TOUR';
      const { isTablet } = useResponsive();
      let labelElement = (
        <FacetLabel count={count}>
          {capitalizeLabels ? capitalizeFromUppercase(label) : label}
        </FacetLabel>
      );

      if (badgeIconProps?.iconName) {
        let newBadgeIconProps = { ...badgeIconProps };

        // Disable cruise & tour icons when full screen
        if (isWorldMapFullScreen && isCruiseOrTour) {
          newBadgeIconProps = {
            ...newBadgeIconProps,
            className: `${newBadgeIconProps.className} cursor-not-allowed border-grey bg-grey`,
          };
        }

        labelElement = <Badge {...newBadgeIconProps} />;

        if (isTablet) {
          const tooltip =
            isWorldMapFullScreen && isCruiseOrTour
              ? t('faceting.filters.typesOfStay.undisplay_product_map')
              : badgeIconProps?.alt;
          labelElement = (
            <PopOver
              ariaLabel={badgeIconProps?.alt || ''}
              content={
                <span className="mb-10 rounded-2 bg-white px-10 py-5 font-sans text-14 font-normal text-black after:drop-shadow-md">
                  {tooltip}
                </span>
              }
              theme="typesOfStaySearchFilter"
              triggerOnHover
            >
              {labelElement}
            </PopOver>
          );
        }
      }

      return {
        isDisabled: isWorldMapFullScreen && isCruiseOrTour,
        isIconOnly: Boolean(badgeIconProps?.iconName),
        isSelected:
          (activeCustomFacets && activeCustomFacets[value]) ||
          (activeFacets && activeFacets[value]),
        label: labelElement,
        value,
      };
    });
};
